import React from 'react';
import DOMPurify from 'dompurify';

export const decode = (str: string) => {
    str = str.replace(/\\n/g, '<br>');
  
    // Sanitize the string to remove any potentially dangerous HTML
    const sanitizedStr = DOMPurify.sanitize(str);

    return <span dangerouslySetInnerHTML={{ __html: sanitizedStr }} />;
};